/*
  Vzvratni dvig krila — opis vsebine in kviz.

  Besedilo po učbeniku in Lukovem pouku. Interaktivni del je v ./sim.js,
  fizika v src/lib/sim/vzvratni.js (pokrita s tests/unit/vzvratni.test.js).
*/
export const MODULE = {
  id: 'vzvratni',
  title: 'Vzvratni dvig krila',
  short: 'V močnejšem vetru: obrnjen proti krilu ga dvigneš, stabiliziraš, se obrneš in vzletiš.',
  meta: '3D simulacija · 3 stopnje',
  vaje: 'Začetni tečaj, vaja 2 · nadaljevalni tečaj, vaja 1',
  icon: 'wind',
  warn: false,
  note: null,
  intro:
    'Vzvratni dvig uporabljaš v močnejšem vetru, od okoli 15 km/h. Obrnjen si proti krilu, s hrbtom v dolino, nosilni trakovi so prekrižani. Krilo ves čas vidiš, zato ga lažje vodiš. Veter ga napolni sam, ti ga le usmerjaš.',
  steps: [
    ['Priprava', 'Krilo razprostreš v lok, se obrneš proti njemu in prekrižaš nosilne trakove. Komandi ostaneta vsaka v svoji roki, zato sta zdaj prekrižani. Smer obrata določiš že zdaj: obrneš se v smer zgornjega traku.'],
    ['Dvig', 'Rahel, enakomeren poteg A trakov. Ne vlečeš, le usmerjaš: veter napolni krilo in ga dvigne. Komand med dvigom ne vlečeš.'],
    ['Ujemi', 'Ko je krilo skoraj nad glavo, A trakove spustiš in ga ustaviš z rahlim zaviranjem. V močnem vetru krilo prehiti hitreje, zato zavreš prej. Spuščene komande v močnem vetru pomenijo, da te krilo prehiti in potegne naprej.'],
    ['Stabilizacija', 'Gledaš v krilo in ga držiš nad glavo. Če gre v tvojo levo, stopiš v levo pod krilo in rahlo zavreš višjo stran. Ker gledaš v krilo, se levo in desno zrcali: zato misliš na višjo stran, ne na levo ali desno roko.'],
    ['Krilo nosi', 'V močnem vetru te krilo lahko potegne ali dvigne. Nikoli ne zaviraš obeh komand do konca na strmini. Korak proti krilu ga razbremeni. Če je treba, ga podreš z zadnjima trakovoma ali z eno komando do konca.'],
    ['Obrat in vzlet', 'Ko je krilo stabilno nad glavo, se obrneš v smer, ki trakove odkriža. Napačna smer pomeni, da ostanejo prekrižani. Komandi sta po obratu v pravih rokah. Takoj tečeš in vzletiš z delno zavrtim krilom, okoli 20 %.'],
  ],
  how: 'Levi in desni drsnik sta komandi glede na krilo: leva komanda krila je leva stran krila, kot ga vidiš pred sabo. Spodnji drsnik Trakovi: v levo potegneš A trakove, v desno zadnja trakova. Drsnik Telo: korak proti krilu ali stran od njega. Korak pod krilo vstran naredi simulacija sama. V stopnji Obrat se pokažeta gumba za obrat v levo in desno. Najprej si oglej pravilno izvedbo.',
  levels: ['dvig', 'obrat', 'veter'],
  store: 'perut-vzvratni-done',
  load: () => import('./sim.js').then((m) => (root, ctx) => m.mountVzvratniSim(root, ctx)),
};

export const KVIZ = [
  {
    q: 'Kdaj uporabiš vzvratni dvig krila?',
    a: ['V brezvetrju, ker je krilo lažje napolniti.', 'V močnejšem vetru, od okoli 15 km/h.', 'Samo na ravnem vzletišču.'],
    ok: 1,
    why: 'Pri vzvratnem dvigu veter sam napolni krilo in ga ves čas vidiš. V brezvetrju ni dovolj vetra, da bi krilo prišlo gor brez teka.',
  },
  {
    q: 'Krilo je stabilno nad glavo. V katero smer se obrneš?',
    a: ['Vedno v levo.', 'V smer, ki trakove odkriža: proti zgornjemu traku, in to določiš že pred dvigom.', 'Vseeno je, trakovi se odkrižajo sami.'],
    ok: 1,
    why: 'Napačna smer pomeni, da trakovi ostanejo prekrižani. Smer določiš že pri pripravi in je vedno ista.',
  },
  {
    q: 'V močnem vetru te krilo začne nositi. Kaj narediš?',
    a: ['Zavrem obe komandi do konca, da krilo ustavim.', 'Stopim proti krilu, da ga razbremenim, in po potrebi podrem z zadnjima trakovoma.', 'Spustim komande in stečem v dolino.'],
    ok: 1,
    why: 'Zaviranje obeh komand do konca na strmini te dvigne. Spuščene komande pomenijo, da te krilo prehiti in potegne naprej. Korak proti krilu razbremeni.',
  },
  {
    q: 'Pri vzvratnem dvigu gre krilo v tvojo levo. Kaj narediš?',
    a: ['Stopim v desno in zavrem levo komando krila.', 'Stopim v levo pod krilo in rahlo zavrem višjo stran.', 'Ostanem na mestu in potegnem A trakove.'],
    ok: 1,
    why: 'Pod krilo stopiš v smer, kamor gre. Ker gledaš v krilo, se levo in desno zrcali, zato zavreš višjo stran, ne po občutku leve ali desne roke.',
  },
  {
    q: 'Kako prekineš vzvratni dvig v močnem vetru?',
    a: ['Zavrem obe komandi do konca.', 'Krilo podrem z zadnjima trakovoma ali z eno komando do konca na stran.', 'Spustim vse in se usedem.'],
    ok: 1,
    why: 'Zadnja trakova krilu odvzameta vzgon, da pade nazaj. Ena komanda do konca ga podre na stran. Obe komandi do konca te v močnem vetru dvigneta.',
  },
];
